import React from 'react';
import './index.module.less';

import { DeviceStatus, IDeviceStatusInfo } from '@apis/types';
import { IDeviceBindInfo } from '@apis/device/getMyDevices';
import BrowserHistory from '@helpers/BrowserHistory';
import { paths } from '@helpers/Constants';

import iconDeviceInfo from './images/device_info_device_default_icon.png';
import iconDeviceQRCode from './images/device_info_qrcode_icon.svg';
import callUtils from '@utils/callUtil';
import { pushAndPopUntil } from '@helpers/BrowserHistory';
import * as Cache from '@helpers/Cache';

interface IProps {
  info: IDeviceBindInfo;
  statusInfo: IDeviceStatusInfo;
}

const MyDeviceCard = (props: IProps) => {

  const { info, statusInfo } = props;
  const deviceIcon = info.iconUrl || iconDeviceInfo;
  const childName = info.bindUserName;
  let deviceSNCode = info.snCode;
  if (deviceSNCode.length >= 4) {
    deviceSNCode = deviceSNCode.substring(deviceSNCode.length - 4, deviceSNCode.length);
  }
  const deviceName = childName ? `${childName}的电子学生证` : `学生证 ${deviceSNCode}`;

  // 在线状态
  const status = statusInfo?.status || DeviceStatus.unknown;
  const online = status === DeviceStatus.online;
  const locked = status === DeviceStatus.locked;
  const forbid = status === DeviceStatus.forbid
  // 状态优先级：禁用 > 锁定 > 离线 > 未开定位 > 在线
  const statusText = locked ? '设备已锁定' : online ? '在线' : '设备已离线';
  const isForbid = forbid ? '设备已禁用' : statusText;
  const power = (online ? statusInfo.electricityRate : '0') || '0';
  const powerValue = Number(power.replace(RegExp('[^0-9]'), ''));
  let powerText = '';
  if (powerValue > 0) {
    if (powerValue <= 20) {
      powerText = `低电量 ${power}`;
    } else {
      powerText = `电量 ${power}`;
    }
  }
  const statusStyle = online ? 'status' : 'status error';

  const toInfoPage = () => {
    BrowserHistory.push(`${PUBLIC_URL}${paths.deviceInfoEntry}?sncode=${info.snCode}`);
  }

  return (
    <div styleName="container">
      <div styleName='device-info' onClick={toInfoPage}>
        <img styleName='device-icon' src={deviceIcon} alt='' />
        <div styleName='device-dec'>
          <div styleName='detail'>
            <div styleName='name'>{deviceName}</div>
            <div styleName='scan-wrapper'>
              <img styleName='scan-icon' src={iconDeviceQRCode} alt='' />
              <i className="iconfont icon-tubiaoyanse" styleName='arrow-icon' />
            </div>
          </div>
          <div styleName='status-wrapper'>
            <div styleName={statusStyle}>{isForbid}</div>
            <div styleName='power'>{powerText}</div>
          </div>
        </div>
      </div>
      <div styleName='device-action'>
        <div styleName='action-button' onClick={() => {
          pushAndPopUntil(null, ['/myDevices', '/']);
          Cache.save('map-sncode', info.snCode);
          BrowserHistory.goBack();
        }}>
          <i className='iconfont icon-position' styleName='icon' style={{ color: '#FF8026' }} />
          <div styleName='text'>实时定位</div>
        </div>
        <div styleName='line' />
        <div styleName='action-button' onClick={() => {
          callUtils.call(info?.snCode);
        }}>
          <i className='iconfont icon-common_family_call_icon' styleName='icon' style={{ color: '#1D70F2' }} />
          <div styleName='text'>亲情通话</div>
        </div>
      </div>
    </div>
  );
};

export default MyDeviceCard;
